import { SettingConst } from '../../types';

/**
 * Control whether to send product events for the brand insights carousel
 */
export const INSIGHT_CAROUSEL_PRODUCT_IMPRESSIONS_241210 =
  'INSIGHT_CAROUSEL_PRODUCT_IMPRESSIONS_241210' as SettingConst<
    'INSIGHT_CAROUSEL_PRODUCT_IMPRESSIONS_241210',
    boolean,
    'RETAILER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
